// component: TimeAndDate
const Months = [
    { month: "فروردین", numOfDays: 31 },
    { month: "اردیبهشت", numOfDays: 31 },
    { month: "خرداد", numOfDays: 31 },
    { month: "تیر", numOfDays: 31 },
    { month: "مرداد", numOfDays: 31 },
    { month: "شهریور", numOfDays: 31 },
    { month: "مهر", numOfDays: 30 },
    { month: "آبان", numOfDays: 30 },
    { month: "آذر", numOfDays: 30 },
    { month: "دی", numOfDays: 30 },
    { month: "بهمن", numOfDays: 30 },
    { month: "اسفند", numOfDays: 29 },
];

// component: TimeSection in TimeAndDate
const timesWork = [
    "10 - 9",
    "11 - 10",
    "12 - 11",
    "13 - 12",
    "14 - 13",
    "15 - 14",
    "16 - 15",
    "17 - 16",
    "18 - 17",
    "19 - 18",
    "20 - 19",
];

// component: ServicesType
const data = [
    "هیرکات",
    "پاکسازی صورت",
    "میکاپ",
    "اصلاح صورت",
    "کراتینه مو",
    "استایل دهی مو",
    "رنگ مو",
    "فر کردن مو",
    "پکیج داماد",
    "ماساژ",
];


export { Months, timesWork, data };
